import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// URL 검색 파라미터 스키마
const agentsSearchSchema = z.object({
  category: z.string().optional().catch(undefined),
});

/**
 * Agents 목록 라우트 (/agents/)
 *
 * validateSearch로 URL 검색 파라미터를 검증합니다.
 * 컴포넌트는 index.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/agents/')({
  validateSearch: agentsSearchSchema,
});
